export default __webpack_public_path__ + "static/media/image.457eec9e.png";